(function () {
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count')); if (isNaN(target)) return;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10); var dur = 1300, start = null;
    function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / dur, 1); var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec); if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec); }
    requestAnimationFrame(step);
  }
  function init(root) {
    if (!root || root.dataset.npReady === '1') return;
    root.dataset.npReady = '1';
    var animOn = root.classList.contains('js-enabled');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = window.Shopify && window.Shopify.designMode;
    // hero image carousel
    var gal = root.querySelector('.hero-gallery');
    if (gal) {
      var slides = gal.querySelectorAll('.hero-slide'), dots = root.querySelectorAll('.hero-dot');
      if (slides.length > 1) {
        var idx = 0, timer = null;
        var go = function (n) {
          slides[idx].classList.remove('is-active'); if (dots[idx]) dots[idx].classList.remove('is-active');
          idx = (n + slides.length) % slides.length;
          slides[idx].classList.add('is-active'); if (dots[idx]) dots[idx].classList.add('is-active');
        };
        var start = function () { if (!reduce) timer = setInterval(function () { go(idx + 1); }, 4000); };
        var stop = function () { if (timer) clearInterval(timer); };
        dots.forEach(function (d, i) { d.addEventListener('click', function () { stop(); go(i); start(); }); });
        var hm = root.querySelector('.hero-media');
        if (hm) { hm.addEventListener('mouseenter', stop); hm.addEventListener('mouseleave', start); }
        start();
      }
    }
    // Theme editor (designMode): never hide content for animation — scroll observers
    // don't fire reliably on the editor's section re-renders, so render fully visible.
    if (animOn && !reduce && !design && 'IntersectionObserver' in window) {
      root.classList.add('js');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
      var counted = false, nums = root.querySelectorAll('[data-count]');
      if (nums.length) {
        var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !counted) { counted = true; nums.forEach(countUp); } }); }, { threshold: 0.6 });
        io2.observe(nums[0]);
      }
    }
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = this.closest('.faq-item'); var was = item.classList.contains('open');
        root.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
        if (!was) item.classList.add('open');
      });
    });
    root.querySelectorAll('.m-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling; var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open)); if (panel) panel.classList.toggle('open', !open);
      });
    });
    root.querySelectorAll('.m-acc-head').forEach(function (h) {
      h.addEventListener('click', function () {
        if (window.innerWidth > 900) return; var body = h.nextElementSibling;
        if (body) body.classList.toggle('open'); h.classList.toggle('open');
      });
    });
  }
  document.querySelectorAll('.np').forEach(init);
  if (!window.__npPersonaBound) {
    window.__npPersonaBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('.np') : null;
      if (r) init(r);
    });
  }
})();
